import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import PersonalInfoComponent from './PersonalInfo';
import ContactInfo from './ContactInfo';
//import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import EditMemberInfo from './EditMemberInfo';
//import APIEndpoints from 'src/Admin/api/APIEndpoints';
//import { HttpSuccessCodes } from 'src/Admin/errorhandling/HttpErrorCodes';
//import { axiosInstance } from 'src/api/axios';
import GenericMessage from 'src/Components/GenericMessage/GenericMessage';
import GenericButton from '../../../../../Components/GenericButton/GenericButton';
import { useNavigate } from 'react-router-dom';
/*import {
  getViewEmployeeDetails,
  getViewContactInformation,
} from '../../../../utils/common';*/
import useProfile from '../../../ViewMember/Profile/hooks/useProfile';
import Skeleton from './skeleton/personalInfoSkeleton';
import './styles/profile.scss';
import './styles/member-info.scss';

const MemberInfo = ({
  nextStep,
  prevStep,
  enrollmentFormData,
  setEnrollmentFormData,
  currentStep,
}) => {
  const [showEditMemberContactDetails, setShowEditMemberContactDetails] =
    useState(false);
  //const [responseData, setResponseData] = useState(null);
  //const [mailingData, setMailingData] = useState({});
  const navigate = useNavigate();
  const {
    employeeInfo,
    PhoneEmailInfo,
    residentialAddress,
    mailingAddress,
    loader,
    dependentsData,
  } = useProfile();
  console.log(
    'MemberInfo employeeInfo',
    employeeInfo,
    residentialAddress,
    mailingAddress,
    loader,
    dependentsData,
  );
  const memberDetailsInfo = {
    MemberInformation: employeeInfo,
    MemberPhoneEmailInfo: PhoneEmailInfo,
    Memberresidentailaddress: residentialAddress,
    Membermailingaddress: mailingAddress,
  };
  //console.log('MemberInfo responseData', responseData);
  console.log('MemberInfo memberDetailsInfo', memberDetailsInfo);

  const memberResidentialAddress =
    enrollmentFormData && enrollmentFormData.updateMemberAddress !== null
      ? enrollmentFormData.updateMemberAddress.maintenanceAddressValues
      : residentialAddress;

  const memberMailingAddress =
    enrollmentFormData && enrollmentFormData.updateMemberAddress !== null
      ? enrollmentFormData.updateMemberAddress.mailingAddressValues
      : mailingAddress;
  /*const { memberDetails } = useSelector((state) => state.memberModule || {});
  const loggedInMemberType = memberDetails?.Member?.LoggedInMemberType;*/

  const { selectedMember } = useSelector((state) => state.memberModule || {});
  const loggedInMemberType = selectedMember.mType;
  console.log('ADMIN ENROLLMENT loggedInMemberType', loggedInMemberType);

  console.log('MemberInfo residentialAddress', memberResidentialAddress);
  console.log('MemberInfo mailingAddress', memberMailingAddress);
  console.log('MemberInfo enrollmentFormData', enrollmentFormData);

  /*const fetchEmployeeData = async () => {
    try {
      const params = `oid/${selectedMember.ID}/membertype/${selectedMember.mType}`;
      const responseEmployeeData = await axiosInstance.get(
        APIEndpoints.getViewMemberinformation() + params,
      );
      console.log(
        'fetchEmployeeData responseEmployeeData :::: >>>>>>>>>>>> ::::::::::: ',
        responseEmployeeData?.data?.Response?.DependentsInfo,
      );
      if (
        responseEmployeeData?.data?.Response?.DependentsInfo &&
        responseEmployeeData?.data?.Response?.DependentsInfo.length > 0
      ) {
        setEnrollmentFormData({
          ...enrollmentFormData,
          dependentsInformation:
            responseEmployeeData?.data?.Response?.DependentsInfo,
        });
      }
      //if (selectedMember.mType === 'Dependent') {
      //setEmployeeData(
      //responseEmployeeData?.data?.Response?.DependentsInformation,
      //);
      //setResidentialData(
      //responseEmployeeData?.data?.Response?.Dependentresidentailaddress[0],
      //);
      //setMailingData(
      //responseEmployeeData?.data?.Response?.Dependentmailingaddress[0],
      //);
      //setDependentsData([]);
      //setLoader(false);
      //} else {
      //setLoader(false);
      //}
    } catch (e) {
      //setLoader(false);
      //setServerError(true);
      console.log('Error >>>>>>>>> ');
    }
  };*/
  useEffect(() => {
    if (
      dependentsData?.length > 0 &&
      enrollmentFormData?.dependentsInformation?.length === 0
    ) {
      setEnrollmentFormData({
        ...enrollmentFormData,
        dependentsInformation: dependentsData,
        isDependentInfoAvailable: true,
        updatedMemberInformation: memberDetailsInfo,
      });
    }
  }, [dependentsData]);
  return (
    <div className="member-info-container">
      {!showEditMemberContactDetails ? (
        <>
          <div className="member-info-header">
            <div>Member Profile</div>
          </div>
          <div className="member-selection-content my-profile-member-container">
            {loader ? (
              <Skeleton />
            ) : (
              <div className="bg-white pt-4 all-profile-component-wrapper">
                <PersonalInfoComponent
                  employeeInfo={employeeInfo}
                  loggedInMemberType={loggedInMemberType}
                />
                <ContactInfo
                  residentialAddress={memberResidentialAddress}
                  mailingAddress={memberMailingAddress}
                  PhoneEmailInfo={PhoneEmailInfo}
                  setShowEditMemberContactDetails={
                    setShowEditMemberContactDetails
                  }
                  showUpdateBtn={
                    enrollmentFormData.selectedEnrollmentFlow ===
                    'AddressChange'
                  }
                />
              </div>
            )}
          </div>
          <div className="padLR-24">
            <GenericMessage
              wrapperClasses="mt-4 mb-4"
              message="Disclaimer Example: Adding a dependent does not automatically enroll them in coverage. After entering your new dependent information you will then have the opportunity to add your dependent to your coverage."
              messageType={'warning'}
              showMessage={true}
              hideCloseButton={true}
            />
          </div>
          <div className="ml4 mr-4 pb-4">
            <Row>
              <Col className="d-flex justify-content-end">
                <GenericButton
                  variant="link"
                  onClick={() => {
                    if (currentStep === 1) {
                      navigate({ pathname: '/member/enrollment-life-event' });
                    } else {
                      prevStep();
                    }
                  }}
                  className="form-btn"
                >
                  Back
                </GenericButton>
                <GenericButton
                  type="button"
                  className="mr-0"
                  onClick={() => nextStep()}
                >
                  Continue
                </GenericButton>
              </Col>
            </Row>
          </div>
        </>
      ) : (
        <EditMemberInfo
          enrollmentFormData={enrollmentFormData}
          setEnrollmentFormData={setEnrollmentFormData}
          nextStep={nextStep}
          prevStep={prevStep}
          setShowEditMemberContactDetails={setShowEditMemberContactDetails}
          employeeInfo={employeeInfo}
          residentialAddress={memberResidentialAddress}
          mailingAddress={memberMailingAddress}
          //setResponseData={setResponseData}
          //responseData={responseData} //Added
        />
      )}
    </div>
  );
};

export default MemberInfo;
